export default "/static/5b506dcfeddb3fd1.png"